// extracted by mini-css-extract-plugin
module.exports = {"stepThree_container":"Success_stepThree_container__1qS_2","arrowLeft":"Success_arrowLeft__1WO26","verification_success":"Success_verification_success__2sy5k"};